import { useEffect, useState, useContext } from "react";
import { BACKEND_API_URL, DISPLAY_LANG } from './config';
import { getHeaderData } from "./api/header";
import { getFooterData } from "./api/footer";
import { getHelpCenterData } from "./api/global";
import useRouter from './hooks/useRouter';
import Header from "./components/header";
import HelpCenter from './components/HelpCenter';
import Footer from "./components/footer";
import CartIcon from "./components/cart-page/CartIcon";
import axios from './axios';

export default function App() {
  const [headerData, setHeaderData] = useState(null);
  const [footerData, setFooterData] = useState(null);
  const [helpCenterData, setHelpCenterData] = useState(null);
  const AppRouter = useRouter();

  useEffect(() => {
    const loadingData = async () => {
      const headerRes = await getHeaderData();
      const footerRes = await getFooterData();
      const helpCenterRes = await getHelpCenterData();

      setHelpCenterData(helpCenterRes);
      setHeaderData(headerRes);
      setFooterData(footerRes);
    };

    loadingData();
  }, []);

  useEffect(() => {
    const websitePassword = async () => {
      try {
        const res = await axios.get('global/website-password');
        const storedPassword = localStorage.getItem('website_password');

        if (res.data.on_off && !storedPassword) {
          while (true) {
            const password = prompt('Enter website password');
            if (password === 'dotigo2026') {
              localStorage.setItem('website_password', true);
              break;
            }
          }
        }
      } catch (error) {
        console.error("An error occurred:", error)
      }
    }

    websitePassword();
  }, []);

  return (
    <div className={`App ${DISPLAY_LANG === 'am' ? 'am-font' : ''}`}>
      {headerData && <Header headerData={headerData} />}
      <main>{AppRouter}</main>
      <CartIcon />
      {helpCenterData && <HelpCenter helpCenterData={helpCenterData} />}
      {footerData && <Footer footerData={footerData} />}
    </div>
  )
}